import React, { createContext } from "react";
import { useAuth } from "./AuthContext";

export const ProductUpdateNotificationsContext = createContext<boolean | undefined>(undefined);

/** Trade alerts are available once the signed-in actor is ready. */
export function ProductUpdateNotificationsProvider({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  const enabled = !isLoading && !!user?.id;

  return <ProductUpdateNotificationsContext.Provider value={enabled}>
    {children}
  </ProductUpdateNotificationsContext.Provider>;
}
